// 3rd
import Swiper, { Navigation } from 'swiper';

const carousels = [...document.querySelectorAll('.carousel')];
const navigationNext = '.navigation-button--next';
const navigationPrev = '.navigation-button--prev';
let slider;

const getHeight = (items) => {
  let maxHeight = 0;

  if (window.innerWidth > 422) {
    items.forEach((item) => {
      if (item.scrollHeight > maxHeight) {
        maxHeight = item.scrollHeight;
      }
    });

    return `${maxHeight}px`;
  }

  return '';
};

const initCarousel = () => {
  carousels.forEach((carousel) => {
    if (slider) slider.destroy();

    const navigation = carousel.querySelector('.carousel__navigation');
    const carouselSlider = carousel.querySelector('.carousel__slider');
    const slides = [...carousel.querySelectorAll('.carousel__slide')];

    // set height (bc of the hover effect)
    slides.forEach((slide) => {
      slide.style.height = '';
      slide.style.height = getHeight(slides);
    });

    if (window.innerWidth > 700 && slides.length > 2) {
      slider = new Swiper(carouselSlider, {
        breakpoints: {
          701: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1001: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
          1301: {
            slidesPerView: 2,
            spaceBetween: 39,
          },
        },
        modules: [Navigation],
        navigation: {
          nextEl: navigationNext,
          prevEl: navigationPrev,
        },
        slidesPerView: 1,
        spaceBetween: 10,
      });

      // show navigation
      navigation.classList.add('carousel__navigation--show');
    } else if (window.innerWidth < 701 && slides.length > 1) {
      slider = new Swiper(carouselSlider, {
        slidesPerView: 1,
        spaceBetween: 10,
      });
    }
  });
};

(() => {
  if (carousels.length > 0) {
    initCarousel();
  }
})();

if (carousels.length > 0) {
  window.addEventListener('resize', () => {
    if (slider) slider.destroy();
    initCarousel();
  });
}
